import React from "react";

const stats = [
  { value: "20,000+", label: "वीडियो लेक्चर्स" },
  { value: "1,00,000+", label: "Practice Questions" },
  { value: "5,000+", label: "Test Papers & PYQs" },
  { value: "25+", label: "Boards Covered" },
];

const StatsBlock = () => {
  return (
    <section
      aria-label="Content depth"
      className="bg-blue-600 text-white py-10 px-4"
    >
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {stats.map((s) => (
          <div key={s.label}>
            <p className="text-3xl sm:text-4xl font-extrabold tracking-tight">
              {s.value}
            </p>
            <p className="mt-1 text-sm sm:text-base text-blue-100">
              {s.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBlock;
